import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  breakpoints,
  fontFamilies,
  palette,
  fontSizes,
  lineHeights,
  fontWeights,
}: Theme) => ({
  formControlRoot: {
    marginBottom: '2rem',
    [breakpoints.up('md')]: {
      paddingTop: 24,
    },
  },
  formLabelRoot: {
    minWidth: 'unset',
    fontSize: fontSizes.lg,
    lineHeight: lineHeights.lg,
    fontFamily: fontFamilies.primary,
    fontWeight: fontWeights.medium,
    color: palette.text.secondary,
    marginBottom: '1.5rem',
    '&$formLabelFocused, &$formLabelError': {
      color: palette.text.secondary,
    },
    [breakpoints.up('md')]: {
      lineHeight: lineHeights.xl,
    },
  },
  formLabelFocused: {},
  formLabelError: {},
  formHelperTextRoot: {
    fontSize: fontSizes.xs,
    lineHeight: lineHeights.sm,
    fontFamily: fontFamilies.primary,
    color: palette.text.secondary,
    margin: '0 0 18px',
    '&$formHelperTextError': {
      color: palette.error.main,
    },
    [breakpoints.up('md')]: {
      fontSize: fontSizes.sm,
      lineHeight: lineHeights.md,
    },
  },
  formHelperTextError: {},
  mmsText: {
    color: palette.grey[700],
    fontSize: fontSizes.xxs,
    marginLeft: '2rem',
    lineHeight: 1.3,
  },
  label: {
    marginBottom: '1.5rem',
    '&:last-of-type': {
      marginBottom: 0,
    },
  },
}));
